import React, { lazy, Suspense } from "react";
import PropTypes from "prop-types";

// Components
import Loading from "./Loading";
const YouTubePlayer = lazy(() => import("react-player/youtube"));
const VimeoPlayer = lazy((() => import("react-player/vimeo")));

/**
 * React Video Player
 */

const VideoPlayer = ({ videoUrl}) => {

	const renderLoader = <Loading color={"blue"} />;

	return (
		<>
			{videoUrl?.includes('vimeo') ? (
				<Suspense fallback={renderLoader}>
					<VimeoPlayer
						height="100%"
						width="100%"
						url={videoUrl}
						playing={false}
						controls={true}
					/>
				</Suspense>
			) : videoUrl?.includes('youtu') ? (
		
				<Suspense fallback={renderLoader}>
					<YouTubePlayer
						height="100%"
						width="100%"
						url={videoUrl}
						playing={false}
						controls={true}
					/>
				</Suspense>
			):
				<div className="video-player__error">Sorry this video format is not supported.</div>
			}
		</>
	);
};

VideoPlayer.propTypes = {
	videoUrl: PropTypes.string
};

export default VideoPlayer;
